import { createLocalStorageProvider } from '@atlassian/jira-browser-storage-providers';
import type { JWMView } from '@atlassian/jira-business-common';

export const getLocalStorage = (view: JWMView) =>
	createLocalStorageProvider(`jira_business_${view}-view`);
